import { render, staticRenderFns } from "./Blod.vue?vue&type=template&id=41390448&"
import script from "./Blod.vue?vue&type=script&lang=js&"
export * from "./Blod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports